import React from "react";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  return (
    <>
      <section className="section1">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-12">
              <h6>De Cafe, the Best in Town</h6>
            </div>
            <div className="col-lg-6 col-12">
              <h6 className="text-right pl-auto">
                Order Online +92-323-4240630
              </h6>
            </div>
          </div>
        </div>
      </section>
      <nav className="navbar navbar-expand-sm navbar-light sticky-top">
        <div className="container">
          <NavLink className="navbar-brand" to="/">
            <strong className="text-white">De Cafe</strong>
          </NavLink>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item active">
                <NavLink className="nav-link" to="/">
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/About">
                  About
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/Service">
                  Manu
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/Contect">
                  Contact
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
